import React, { Component, Suspense } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { Link } from "react-router-dom";
// import { API_KEY } from "./config";
import styled from "styled-components";
import "../styles/navbar.scss";
import Movies from "./Movies/Movies";
import Navbar from "./Navbar";
import Skeleton from "./Skeleton";
import { HR, mainBackgroundColor } from "./StyledComponents";
import { above, below } from "./utils";

class MovieList extends Component {
  state = {
    items: 20,
    inputValue: "",
    movies: ["Captain Marvel", "Captain America", "Avengers", "Godzilla"],
    searchedMovies: [],
    suggestion: [],
    isNavOpen: false,
  };

  handleInput = (text) => {
    this.setState({ inputValue: text });
    if (text && text.trim().length > 2) this.onMovieSearched(text);
  };
  /* onMovieSearched = async text => {
    if (text && text.trim() !== "") {
      let suggestion = [];
      suggestion = this.state.movies.map(movie => {
        if (movie.toLowerCase().startsWith(text.toLowerCase())) {
          return movie;
        }
      });
      console.log(suggestion);
      if (text.length > 2) {
        this.setState({ suggestion });
      }
    } else {
      console.log("Else called");
      this.setState({ suggestion: [] });
    }
  }; */
  render() {
    const {
      data,
      heading,
      items,
      fetchMoreMovies,
      totalMovies,
      loading,
      error,
    } = this.props;
    const { inputValue, movies } = this.state;
    // let suggestion = [];
    // if (inputValue && inputValue.trim() && inputValue.length > 2) {
    //   suggestion = movies.map(movie => {
    //     if (movie.toLowerCase().startsWith(inputValue.toLowerCase())) {
    //       return movie;
    //     }
    //     return undefined;
    //   });
    // }
    return (
      <React.Fragment>
        <Suspense>
          <Navbar></Navbar>
        </Suspense>
        <Container>
          {heading && (
            <h2 className="pl-2 mt-20 mb-6 text-xl font-bold border-l-4 border-gray-900 md:mb-4 md:border-l-8 md:text-2xl">
              {heading}
            </h2>
          )}
          {error ? (
            <div className="flex flex-col pt-5" style={{ height: "60vh" }}>
              <h2 className="text-sm md:text-2xl">
                Couldn't fetch movies{" "}
                <span role="img" aria-label="sad">
                  😥
                </span>
              </h2>
              <p className="text-xs md:text-lg">Try refreshing the page</p>
            </div>
          ) : loading ? (
            <Skeleton />
          ) : (
            <React.Fragment>
              {/*  <Skeleton /> */}

              {
                <InfiniteScroll
                  dataLength={items}
                  next={fetchMoreMovies}
                  hasMore={data.length < totalMovies}
                  endMessage={<HR />}
                  loader={<Skeleton />}
                >
                  <div className="mt-4 lg:mt-10">
                    <Movies movies={data} />
                  </div>
                </InfiniteScroll>
              }
            </React.Fragment>
          )}
        </Container>
      </React.Fragment>
    );
  }
}
export const Container = styled.div`
  width: 95%;
  /* background: #000; */
  margin: 0 auto;
  ${above.small`
    margin: 0 auto;
    width: 90%;
  `}
  ${above.med`
    margin: 0 auto;
  `}
`;
// export const Container = ({ children }) => (
//   <div className="container w-full px-4 mx-auto sm:px-0">{children}</div>
// );
export const Heading = styled.h1`
  position: relative;
  display: inline-block;
  z-index: 1;
  font-size: 1.2rem;
  font-weight: 500;
  ${(props) => props.marginTop && `margin-top: ${props.marginTop}`}
  &::before {
    content: "";
    z-index: -1;
    width: 5px;
    position: absolute;
    height: 100%;
    left: -15px;
    ${mainBackgroundColor};
  }
  ${below.small`
  margin-top: 2rem;
  font-size: 1.3rem;
  `}
  ${below.med`
  margin-top: 3rem;
  `}
  margin-bottom: 1rem;
  ${above.large`
    font-size: 1.5rem;
    margin-bottom: 0rem;
  `};
`;
export const Wrapper = styled.div`
  ${(props) => props.marginTop && `margin-top: ${props.marginTop}rem;`}
  display: grid;
  width: 100%;
  height: 100%;
  gap: 10px;
  margin: 2rem 0;
  ${below.med`
    grid-template-columns: repeat(2,1fr);
  `}
  ${above.med`
    grid-template-columns: repeat(3,1fr);
  `}  
  ${above.large`
      grid-template-columns: repeat(5, 1fr);
    `}
`;

export default MovieList;
